import PropTypes from 'prop-types';
import React from 'react';
import config from '../../config';

const SurflineIcon = ({theme}) => {
  const target = theme === 'account' ? '' : '_blank';
  return (
    <div className="brand-icons__ul__sl">
      <a target={target} href={config.surflineHome}>
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22" viewBox="0 0 17 22">
          <path fill="#FFF" fillRule="evenodd" d="M8.111 19.045a5.28 5.28 0 0 1-1.324-.186c2.297-.567 4.015-2.65 4.048-5.154.01-.743.611-1.337 1.345-1.326.732.01 1.318.62 1.308 1.36-.04 2.972-2.447 5.345-5.377 5.306zm-3.925-4.086a1.336 1.336 0 0 1-1.31-1.362c.04-2.97 2.446-5.345 5.377-5.305.458.006.902.071 1.325.187-2.298.566-4.016 2.648-4.05 5.153a1.334 1.334 0 0 1-1.342 1.327zm11.41-4.796C14.677 7.781 8.18 0 8.18 0S1.684 7.78.767 10.163A8.337 8.337 0 0 0 0 13.667c0 4.58 3.663 8.29 8.181 8.29 4.519 0 8.181-3.71 8.181-8.29 0-1.251-.275-2.439-.767-3.504z"/>
        </svg>
      </a>
    </div>
  );
};

SurflineIcon.propTypes = {
  theme: PropTypes.string.isRequired
};

export default SurflineIcon;
